import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsassuranceiconsvg = lazy(() => import('./svg-components/digital-forms-assurance-icon-svg'));

const DigitalFormsAssuranceIconSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsassuranceiconsvg {...rest} />
  </Suspense>
);

export default DigitalFormsAssuranceIconSvg;
